/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SectionsList_recipe$ref: FragmentReference;
declare export opaque type SectionsList_recipe$fragmentType: SectionsList_recipe$ref;
export type SectionsList_recipe = {|
  +section: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +recipe: {|
          +name: string
        |},
        +recipeingredientSet: ?{|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +comments: ?string,
              +ingredient: {|
                +name: string,
                +id: string,
              |},
              +unityF: ?{|
                +id: string
              |},
              +unity: ?string,
              +qty: ?string,
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$refType: SectionsList_recipe$ref,
|};
export type SectionsList_recipe$data = SectionsList_recipe;
export type SectionsList_recipe$key = {
  +$data?: SectionsList_recipe$data,
  +$fragmentRefs: SectionsList_recipe$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "section"
        ]
      }
    ]
  },
  "name": "SectionsList_recipe",
  "selections": [
    {
      "alias": "section",
      "args": null,
      "concreteType": "RecipeSectionNodeConnection",
      "kind": "LinkedField",
      "name": "__SectionsList_section_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecipeSectionNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecipeSectionNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecipeNode",
                  "kind": "LinkedField",
                  "name": "recipe",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecipeIngredientNodeConnection",
                  "kind": "LinkedField",
                  "name": "recipeingredientSet",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RecipeIngredientNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RecipeIngredientNode",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "comments",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "IngredientNode",
                              "kind": "LinkedField",
                              "name": "ingredient",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                (v0/*: any*/)
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "UnitMeasureNode",
                              "kind": "LinkedField",
                              "name": "unityF",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/)
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "unity",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "qty",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecipeNode"
};
})();
// prettier-ignore
(node/*: any*/).hash = '1384d113a6cf3817c4068125b64081a9';

module.exports = node;
